import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const buyers = [{
  name: 'Valentina G.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía M.',
  city: 'Córdoba'
}, {
  name: 'Martina L.',
  city: 'Rosario'
}, {
  name: 'Camila R.',
  city: 'Mendoza'
}, {
  name: 'Julieta P.',
  city: 'La Plata'
}, {
  name: 'Florencia S.',
  city: 'Mar del Plata'
}, {
  name: 'Agustina T.',
  city: 'Salta'
}, {
  name: 'Micaela B.',
  city: 'Tucumán'
}, {
  name: 'Lucía F.',
  city: 'Neuquén'
}, {
  name: 'Carla D.',
  city: 'Santa Fe'
}, {
  name: 'Brenda V.',
  city: 'San Juan'
}, {
  name: 'Rocío A.',
  city: 'Bahía Blanca'
}, {
  name: 'Daniela C.',
  city: 'Resistencia'
}, {
  name: 'Antonella M.',
  city: 'Posadas'
}, {
  name: 'Belén O.',
  city: 'Paraná'
}];
const offers = [{
  name: 'Pack Pro',
  price: '$24.990'
}, {
  name: 'Pack Full Access',
  price: '$29.990'
}];
interface Sale {
  name: string;
  city: string;
  offer: string;
  price: string;
  minutesAgo: number;
}
function randomSale(): Sale {
  const buyer = buyers[Math.floor(Math.random() * buyers.length)];
  const offer = offers[Math.floor(Math.random() * offers.length)];
  return {
    name: buyer.name,
    city: buyer.city,
    offer: offer.name,
    price: offer.price,
    minutesAgo: Math.floor(Math.random() * 8) + 1
  };
}
export function PurchasePopup() {
  const [sale, setSale] = useState<Sale | null>(null);
  const showSale = useCallback(() => {
    setSale(randomSale());
    // Hide this toast after ~6 seconds.
    window.setTimeout(() => setSale(null), 6000);
  }, []);
  useEffect(() => {
    let nextTimeout: number;
    let hideTimeout: number;
    const scheduleNext = () => {
      // Random interval between 40s and 60s.
      const delay = (Math.floor(Math.random() * 21) + 40) * 1000;
      nextTimeout = window.setTimeout(() => {
        setSale(randomSale());
        hideTimeout = window.setTimeout(() => setSale(null), 6000);
        scheduleNext();
      }, delay);
    };
    // First toast appears shortly after load.
    const initial = window.setTimeout(() => {
      showSale();
      scheduleNext();
    }, 5000);
    return () => {
      window.clearTimeout(initial);
      window.clearTimeout(nextTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, [showSale]);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] pointer-events-none" data-id="element-234">
      <AnimatePresence data-id="element-235">
        {sale && <motion.div initial={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} role="status" aria-live="polite" className="pointer-events-auto flex items-center gap-3 bg-violet-deep border border-gold/30 rounded-xl shadow-2xl px-3 py-3 pr-9 sm:pr-10 w-[300px] sm:w-[340px] relative" data-id="element-236">
            <span className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-green/15 flex items-center justify-center" data-id="element-237">
              <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-green" data-id="element-238" />
            </span>
            <div className="min-w-0" data-id="element-239">
              <p className="text-[10px] sm:text-xs text-gold font-semibold tracking-wide mb-0.5" data-id="element-240">
                COMPRA VERIFICADA
              </p>
              <p className="text-xs sm:text-sm text-white leading-snug" data-id="element-241">
                <span className="font-semibold" data-id="element-242">{sale.name}</span> de{' '}
                <span className="font-semibold" data-id="element-243">{sale.city}</span> compró el{' '}
                <span className="font-semibold text-gold" data-id="element-244">{sale.offer}</span>
              </p>
              <p className="text-[10px] sm:text-[11px] text-violet-100/50 mt-0.5" data-id="element-245">
                {sale.price} · hace {sale.minutesAgo} min
              </p>
            </div>
            <button onClick={() => setSale(null)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-violet-100/40 hover:text-violet-100/80 transition-colors" data-id="element-246">
              <X className="w-4 h-4" data-id="element-247" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}